import React, { useState } from 'react';
import PrimaryNavigation from '../ui/PrimaryNavigation';
import MobileMenuButton from '../ui/MobileMenuButton';
import MobileMenuOverlay from '../ui/MobileMenuOverlay';
import NavigationBreadcrumbs from '../ui/NavigationBreadcrumbs';
import QuickActionMenu from '../ui/QuickActionMenu';
import Footer from './Footer';

const MainLayout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <PrimaryNavigation />
      
      <MobileMenuButton
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        isOpen={isMobileMenuOpen} />


      <MobileMenuOverlay
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)} />


      <NavigationBreadcrumbs />

      <main className="main-content flex-1 pt-2.5">
        <div className="main-content-inner pt-[50px] -mt-2.5">
          {children}
        </div>
      </main>

      <Footer />
      <QuickActionMenu />
    </div>);

};

export default MainLayout;